import Component from 'flarum/common/Component';
import LoadingIndicator from "flarum/components/LoadingIndicator";
import Stream from 'flarum/utils/Stream';

import roundValue from "../common/util/roundValue";
import itemColor from "../common/util/itemColor";
import getInfoData from "../common/util/getInfoData";
import ItemQueryModal from './modal/ItemQueryModal';
import ItemDistributeModal from './modal/ItemDistributeModal';
import ItemReportModal from './modal/ItemReportModal';
import UserSubmitModal from "./modal/UserSubmitModal";
import getUserInfo from "../common/util/getUserInfo";
import playVideoModal from "./modal/playVideoModal";

export default class MapModule extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.mapModuleID = this.attrs.mapModuleID;
    this.mapClassName = this.attrs.mapClassName;
    this.mapModuleSearchResultID = this.mapModuleID+"SearchResult";
    this.mapModuleTempContainer = this.mapModuleID+"TempContainer";
    this.mapWidth = this.attrs.mapWidth || "100%";
    this.mapHeight = this.attrs.mapHeight || "100%";
    this.mapInfoDataList = this.attrs.mapInfoDataList || [];

    this.U2DiAmapApiKey = app.forum.attribute("U2DiAmapApiKey");
    this.U2DiAmapApiSecret = app.forum.attribute("U2DiAmapApiSecret");
    this.mapModule = null;
    this.geoCoder = null;
    this.mapCluster = null;
    this.mapInfoWindow = null;
    this.mapModuleCallback = this.attrs.mapModuleCallback || null;

    this.clusterCount = 0;
    this.addInfoData = null;
    this.zoomedOut = false;
    this.selectedMarkerInfo = null;

    this.mapGeocoderEventListener = this.attrs.mapGeocoderEventListener || null;
    this.mapClickEventListener = this.attrs.mapClickEventListener || null;

  }

  oncreate(vnode) {
    super.oncreate(vnode);
    const _this = this;

    if(!window._AMapSecurityConfig){
      window._AMapSecurityConfig = {securityJsCode:this.U2DiAmapApiSecret};

      let mapApi = document.createElement('script');
      mapApi.charset = 'utf-8';
      mapApi.src = 'https://webapi.amap.com/maps?v=2.0&key='+this.U2DiAmapApiKey+'&callback=onLoad';
      document.head.appendChild(mapApi);

      window.onLoad = function(){
        _this.initMap();
        _this.initListeners();
      }
    }else{
      _this.initMap();
      _this.initListeners();
    }
  }

  initMap() {
    this.mapModule = new AMap.Map(this.mapModuleID,{
       // center:[116.407394,39.904202],
       zoom:4.5,
       resizeEnable: true,
       mapStyle: "amap://styles/light",
       zooms: [4,20],
       WebGLParams: {
        preserveDrawingBuffer: true
      }
    });


    // this.setMapStyle();

      // const marker = _this.addMarker({
      //   lng:infoLng,
      //   lat:infoLat
      // },function(e){ 
      //   let position = e.clusterData[0].lnglat;
      //   _this.mapModule.setCenter([infoLng,infoLat],false,330);
      //   _this.addInfoWindow(position,,new AMap.Pixel(0, -34));
      // });
  }

  initListeners(){
    const _this = this;

    $(".item-nightmode").on('click',function(e){
      // _this.setMapStyle();
    });

    if(_this.mapGeocoderEventListener){
      _this.mapModule.plugin(["AMap.Geocoder"], function() { 
         _this.geoCoder = new AMap.Geocoder();
         _this.geoCoder.on("complete", function(result){
            // console.log(result)
            _this.mapGeocoderEventListener(result);
            _this.enableMap();
         });
      });
    }

    _this.mapModule.on('click',function(e){
        const lng = e.lnglat.getLng();
        const lat = e.lnglat.getLat();
        console.log('您在[ '+lng+','+lat+' ]的位置点击了地图！');

        if(_this.mapClickEventListener){
          _this.mapClickEventListener({lng:lng,lat:lat});
        }

        if(_this.mapGeocoderEventListener){
          _this.disableMap();
          _this.geoCoder.getAddress(new AMap.LngLat(lng, lat));
        }

        if(_this.mapInfoWindow){
          _this.mapModule.emit('clearInfoWindow');
        }
    });

    _this.mapModule.on("clearInfoWindow", function(){
      $("#u2diMapClusterMarkerContainer"+_this.selectedMarkerInfo).removeClass("u2diMapClusterSelectedMarker");
      _this.selectedMarkerInfo = null;
      _this.mapModule.clearInfoWindow();
      window.selectedTargetID = null;
      m.redraw();
    });

    _this.mapModule.on("zoomchange", function(){
      // _this.mapModule.emit('clearInfoWindow');
      // console.log(_this.mapModule.getZoom());
    });

    _this.mapModule.on("mapAddCluster", function(e){
      let cluster = e.cluster;

      if(_this.mapCluster){
        _this.mapCluster.setData([]);
        _this.mapCluster = null;
      }

      _this.addCluster(cluster,function(e){
        let clusterData = e.clusterData;
        let markerHeight = e.marker._size[1];
        let position;

        if(clusterData.length>1 || clusterData[0]._amapMarker.count>1){
          let currentZoom = _this.mapModule.getZoom();
          position = e.lnglat;

          _this.mapModule.emit('clearInfoWindow');
          _this.mapModule.setZoomAndCenter(currentZoom+1,position,false,330);
        }else{
          let itemID = clusterData[0].itemID;
          let dataType = clusterData[0].dataType;
          let offset = new AMap.Pixel(0, -markerHeight);
          position = clusterData[0].lnglat;

          _this.mapModule.emit('mapItemSelect',{
              position : position,
              itemID: itemID,
              offset: offset,
              dataType: dataType
          });
        }
      });
    });

    _this.mapModule.on("mapAddMarker", function(e){
      let params = e.params;
      _this.addMarker(params);
    });

    _this.mapModule.on("mapItemSelect", function(e){
      let position = e.position;
      let latOffset = 0.02;
      let itemID = e.itemID;
      let targetID = e.targetID;
      let dataType = e.dataType;
      let offset = e.offset || new AMap.Pixel(0, -34);
      let zoom = 12;

      offset.y-=12;

      let mapPosition = _this.mapModule.getCenter();
      let mapZoom = _this.mapModule.getZoom();

      _this.mapModule.emit('clearInfoWindow');
      _this.disableMap();
      _this.addInfoData = {dataType:dataType,itemID:itemID,position:position,offset:offset};
      _this.selectedMarkerInfo = itemID;
      window.selectedTargetID = targetID?targetID:itemID;

      $("#u2diMapClusterMarkerContainer"+_this.selectedMarkerInfo).addClass("u2diMapClusterSelectedMarker");

      if(mapZoom===zoom && roundValue(mapPosition.lng,11)===roundValue(position.lng,11) && roundValue(mapPosition.lat,11)===roundValue(position.lat+latOffset,11)){
        _this.mapModule.emit('moveend');
      }else{
        if(mapZoom>=zoom){
          _this.mapModule.setZoom(mapZoom-2,false,660);

          setTimeout(function(){
            _this.mapModule.setZoomAndCenter(zoom,[position.lng,position.lat+latOffset],false,500);
          },500);
        }else{
          _this.mapModule.setZoomAndCenter(zoom,[position.lng,position.lat+latOffset],false,500);
        }
      }
    });

    _this.mapModule.on("mapZoomOut", function(e){
      let mapZoom = _this.mapModule.getZoom();
      let zoom = e.zoom;
      let position = e.position;

      if(mapZoom!==zoom){
        _this.disableMap();
        _this.mapModule.setZoomAndCenter(zoom,position,false,660);
        _this.zoomedOut = true;
      }
    });

    _this.mapModule.on("moveend", function(){
      if(_this.addInfoData!==null){
        let addInfoData = _this.addInfoData;
        _this.addInfoWindow(addInfoData.dataType,addInfoData.itemID,addInfoData.position,addInfoData.offset);
        _this.addInfoData = null;
        _this.enableMap();
      }

      if(_this.zoomedOut===true){
        _this.enableMap();
      }
    });

    _this.mapModule.on("complete", function(){
       _this.initComponents();

       if(_this.mapModuleCallback!==null){
          _this.mapModuleCallback(_this.mapModule);
       }
       
       $(".amap-copyright").text(" - GS(2021) 6375号");
       m.redraw();
    });
  }

  setMapStyle() {
      let forumStyle = document.querySelector('link.nightmode[rel=stylesheet]');

      if(forumStyle===null){
        forumStyle = document.querySelector('link.nightmode-light[rel=stylesheet]') || document.querySelector('link.nightmode-dark[rel=stylesheet]');
      }

      console.log(forumStyle);
      if(forumStyle){
        if((forumStyle.href).indexOf("forum-dark")===-1){
          (this.mapModule).setMapStyle("amap://styles/normal");
        }else{
          (this.mapModule).setMapStyle("amap://styles/dark");
        }
      }else{
          (this.mapModule).setMapStyle("amap://styles/normal");
      }
  }

  initComponents() {
    const _this = this;
    const cluster = [];
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    for(let index in _this.mapInfoDataList){
      const itemData = _this.mapInfoDataList[index];
      const itemCategory = itemData.category;
      const itemID = itemData.id;
      const itemSN = itemData.sn;
      const userID = itemData.user_id;
      const itemLat = itemData.lat;
      const itemLng = itemData.lng;
      const itemPrice = itemData.price;
      const itemType = itemData.type;
      const itemStatus = itemData.status;
      const itemFlag = itemData.flag;
      const assignedAt = itemData.assignedAt;
      let itemLatModifier = 0;
      let itemLngModifier = 0;
      
      if(itemFlag!==1){
        if((app.session.user && userID==app.session.user.id()) || u2diUserType9===true){
          let userInfo = getUserInfo(app.session.user.id());
          let assignedAt = userInfo.assignedAt();
          let key = (itemSN%5)*2+1;
  
          itemLatModifier=(assignedAt[key]/10/100);
          itemLngModifier=(assignedAt[key+1]/10/100);
        }
      }

      cluster.push({
        lnglat:[itemLng+itemLngModifier,itemLat+itemLatModifier],
        itemID:itemID,
        userID:userID,
        price:itemPrice,
        type:itemType,
        category:itemCategory,
        status:itemStatus,
        dataType:"info"
      });
    }

    this.mapModule.emit('mapAddCluster',{
        cluster : cluster,
    });
  }

  addInfoWindow(dataType,itemID,position,offset){
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const _this = this;
    const selectedCategory = window.selectedCategory;
    let info = [];

    info.push('<div style="width:250px;height:200px;color: var(--control-color);padding: 0px 10px;display: flex;justify-content: center;align-items: center;">');
    info.push('<div style="scale:0.5" class="u2di-loading"><div></div><div></div><div></div></div>');
    info.push('</div>');

    if(u2diUserType9===true){
      if(dataType==="info"){
        dataType = "infoAdmin";
      }else if(dataType==="distribute"){
        dataType = "distributeAdmin";
      }
    }else if(u2diUserType0===true){
      if(dataType==="info"){
        dataType = "infoYouKe";
      }else if(dataType==="distribute"){
        dataType = "distributeYouKe";
      }
    }

    console.log(itemID,dataType);

    const infoWindow = new AMap.InfoWindow({
      content: info.join(""),
      offset: offset
    });

    infoWindow.on('close', function(){
      _this.mapInfoWindow = null;
    });

    infoWindow.open(_this.mapModule, position);
    _this.mapInfoWindow = infoWindow;

    getInfoData(dataType,itemID,function(info,ts,infoData,targetData,infoDetailsData){
      infoWindow.setContent(info);

      let timeoutId;
      $('#u2diInfoNoteInputArea'+ts).on('input propertychange change', function() {
          clearTimeout(timeoutId);
          $("#u2diInfoNoteInputAreaStatus"+ts).hide();

          timeoutId = setTimeout(function() { 
            targetData.save({note:$("#u2diInfoNoteInputArea"+ts).val()}).then(() => {
              $("#u2diInfoNoteInputAreaStatus"+ts).show();
            });
          }, 1500);
      });

      let infoBaseData;

      if(infoData.data.type==="u2diInfoDistributes"){
        infoBaseData = infoData.u2diBaseData();
      }else{
        infoBaseData = infoData;
      }

      const infoFlag = infoBaseData.flag();
      const bilibiliLink = infoBaseData.bilibiliLink();

      if(bilibiliLink){
        $("#u2diCardVideoLink"+ts).html('<span style="cursor:pointer;font-size:14px;"><i style="margin-right: 5px;color: #00A1D6;" class="fas fa-play-circle"></i></span>');

        $("#u2diCardVideoLink"+ts).on('click',function(){
          app.modal.show(playVideoModal,{link:bilibiliLink});
        });
      }

      if(infoFlag===1){
        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const option_zpzl = zcxx.option_zpzl[0];

        window.previewImageList = zcxx.option_zpzl;
        $(".u2diItemDetailsMiscDeposit").on('click',function(){
          if(window.previewImageList.length>0){
            $(".u2diUploadPreviewModal-right").show();
          }
          
          $("#u2diUploadPreviewModal").css("display","flex");
          $("#u2diUploadPreviewModal-content").attr("src", option_zpzl.path);
          $("#u2diUploadPreviewModal-caption").text(option_zpzl.name);
        });
      }

      $("#u2diItemInfoDetailsButton"+ts).on('click',function(){
        const info_zcxx = JSON.parse(infoDetailsData.zcxx());
        const info_ghtj = JSON.parse(infoDetailsData.ghtj());
        const info_jjxx = JSON.parse(infoDetailsData.jjxx());
        const info_lxxx = infoDetailsData.lxxx()==="{}"?{}:JSON.parse(CryptoJSAesJson.decrypt(infoDetailsData.lxxx(), (infoDetailsData.base_id()).toString()));

        const wrapData = {
          selectedType:infoBaseData.category(),
          initType:"resume",
          viewType:"edit",
          from:"info",
          targetData: infoBaseData,
          targetDetailsData: infoDetailsData,
          reports:infoBaseData.reports(),
          option_zcqs: Stream(info_zcxx.option_zcqs),
          option_lzxz: Stream(info_zcxx.option_lzxz),
          option_lzxz_checked: Stream(info_zcxx.option_lzxz_checked),
          option_zclb: Stream(info_zcxx.option_zclb),
          option_zcwz: Stream(info_zcxx.option_zcwz),
          option_tdmj: Stream(info_zcxx.option_tdmj),
          option_jzmj: Stream(info_zcxx.option_jzmj),
          option_jzmj_disabled:Stream(info_zcxx.option_jzmj_disabled),
          option_synx: Stream(info_zcxx.option_synx),
          option_zcdb: Stream(info_zcxx.option_zcdb),
          option_zpzl: Stream(info_zcxx.option_zpzl),
          option_ystd: Stream(info_zcxx.option_ystd),

          option_ghtj: Stream(info_ghtj.option_ghtj),
          option_wjzl: Stream(info_ghtj.option_wjzl),
          option_ydmj: Stream(info_ghtj.option_ydmj),
          option_rjl: Stream(info_ghtj.option_rjl),
          option_ldl: Stream(info_ghtj.option_ldl),
          option_jzmd: Stream(info_ghtj.option_jzmd),
          option_jzxg: Stream(info_ghtj.option_jzxg),
          option_jzxg_disabled: Stream(info_ghtj.option_jzxg_disabled),

          // option_ysx: Stream(info_jjxx.option_ysx),
          // option_cjjg: Stream(info_jjxx.option_cjjg),
          option_crxs: Stream(info_jjxx.option_crxs),
          option_ssyq: Stream(info_jjxx.option_ssyq),
          option_ssyq_checked: Stream(info_jjxx.option_ssyq_checked),
          option_ysdj: Stream(info_jjxx.option_ysdj),
          option_yqjg: Stream(info_jjxx.option_yqjg),
          option_jjbl: Stream(info_jjxx.option_jjbl),
          option_zsyq: Stream(info_jjxx.option_zsyq),

          option_lxxx: Stream(info_lxxx.option_lxxx),
          option_bmqy: Stream(info_lxxx.option_bmqy),
          option_zjgw: Stream(info_lxxx.option_zjgw),
          option_zsxm: Stream(info_lxxx.option_zsxm),
          option_zsxm_title: Stream(info_lxxx.option_zsxm_title),
          option_lxdh: Stream(info_lxxx.option_lxdh),
          option_lxdh_checked: Stream(info_lxxx.option_lxdh_checked),
          option_lxdh_wx_value: Stream(info_lxxx.option_lxdh_wx_value),
          option_lxdh_wx_value_disabled: Stream(info_lxxx.option_lxdh_wx_value_disabled),
        };

        app.modal.show(UserSubmitModal,{wrapData})
      });

      $(".u2diItemDetailsQueryButton").on('click',function(){
        app.modal.show(ItemQueryModal,{infoBaseData})
      });

      $(".u2diItemDetailsDistributeButton").on('click',function(){
        app.modal.show(ItemDistributeModal,{infoBaseData,callback:function(){
          _this.addInfoWindow(dataType,itemID,position,offset);
        }})
      });

      $(".u2diItemDetailsReportButton").on('click',function(){
        app.modal.show(ItemReportModal,{infoBaseData})
      });

    })

    return infoWindow;
  }

  addCluster(points,clickEvent) {
    //

    const _this = this;
    this.clusterCount = points.length;

    _this.mapModule.plugin(["AMap.MarkerClusterer"],function() {
      let cluster = _this.mapCluster = new AMap.MarkerCluster(_this.mapModule, points, {
          gridSize: 60,
          renderClusterMarker: function(context){
            let count = _this.clusterCount;
            let bgColor;
            let clusterCount = context.count;
            let size = 70;
            const mapZoom = _this.mapModule.getZoom();
            var div = document.createElement('div');
            var defaultColor = [
                '0,0,255',
                '0,0,255',
                '0,0,255',
                '0,0,255',
                '0,0,255',
                '204,235,197',
                '168,221,181',
                '123,204,196',
                '78,179,211',
                '43,140,190',
            ]
            if(clusterCount >= 0 && clusterCount < 10) {
                bgColor = defaultColor[0];
                size = 20;
            } else if(clusterCount >= 10 && clusterCount < 100){
                bgColor = defaultColor[1];
                size = 20;
            } else if(clusterCount >= 100 && clusterCount < 1000) {
                bgColor = defaultColor[2];
                size = 30;
            } else if(clusterCount >= 1000 && clusterCount < 10000) {
                bgColor = defaultColor[3];
                size = 40;
            } else if(clusterCount >= 10000) {
                size = 50;
                bgColor = defaultColor[4];
            } else if(clusterCount >= 100000) {
                bgColor = defaultColor[4];
                size = 60;
            }

            div.style.backgroundColor = 'rgba(' + bgColor + ',.8)';
            div.style.width = div.style.height = size + 'px';
            div.style.border = 'solid 1px rgba(' + bgColor + ',1)';
            div.style.borderRadius = "100%";
            div.innerHTML = clusterCount;
            div.style.lineHeight = (size-3) + 'px';
            div.style.color = '#ffffff';
            div.style.fontSize = '12px';
            div.style.textAlign = 'center';
            context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
            context.marker.setContent(div);
          }, 
          renderMarker: function(context){  // 自定义非聚合点样式
            let contextData = context.data[0];
            let infoID = contextData.itemID;
            let price = (contextData.price).split(" ");
            let priceText = price[0];
            let priceUnit = price[1];
            let type = contextData.type;
            let status = contextData.status;
            let category = contextData.category;

            if(status===1){
              type = category+"_none";
            }

            let color = itemColor(type);
            let u2diMarkerContainerClassName = "u2diMarkerContainer";

            if(_this.selectedMarkerInfo==infoID){
              u2diMarkerContainerClassName+=" u2diMapClusterSelectedMarker";
            }

            let content = '<div id="u2diMapClusterMarkerContainer'+infoID+'" style="color:rgb('+color+');background:rgba('+color+');border-color:rgb('+color+')" class="'+u2diMarkerContainerClassName+'"><div class="u2diMarker u2diMarker_'+type+'"></div><div class="u2diMapClusterMarkerText u2diMapClusterMarkerText_'+category+'">'+priceText+" <span style='font-size:12px'>"+priceUnit+'</span></div></div>';

            $("#"+_this.mapModuleTempContainer).html(content);

            let markerSizeX = $("#"+_this.mapModuleTempContainer).outerWidth();
            let markerSizeY = $("#"+_this.mapModuleTempContainer).outerHeight();
            let offset = new AMap.Pixel(-markerSizeX/2, -markerSizeY);
            context.marker.setContent(content);
            context.marker.setOffset(offset);
          },
      });

      if(typeof(clickEvent)==="function"){
        cluster.on('click',function(e){ clickEvent(e); });
      }
    });
  }

  addMarker(params,clickEvent) {
    const markerTitle = params.title || "";
    const markerLng = params.lng;
    const markerLat = params.lat;
    const markerIcon = params.icon || "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png";
    const markerPosition =new AMap.LngLat(markerLng, markerLat);
    const clearAllMarker = params.clearAllMarker || false;
    const centerMap = params.centerMap || false;
    const showInfo = params.showInfo;

    if(clearAllMarker===true){
      this.mapModule.clearMap();
    }

    if(centerMap===true){
      this.mapModule.setCenter(markerPosition,false,330);
    }

    const marker = new AMap.Marker({
      icon: markerIcon,
      position: markerPosition,
      title: markerTitle,
      offset: new AMap.Pixel(-12, -28)
    });

    if(markerTitle!=="" && showInfo===true){
      const markerText = new AMap.Text({
          text:markerTitle,
          anchor:'center',
          draggable:false,
          angle:0,
          style:{
              'padding': '10px 20px',
              'margin-bottom': '1rem',
              'border-radius': '6px',
              'background-color': 'var(--body-bg)',
              'width': '15rem',
              'border-width': 0,
              'box-shadow': '0 2px 6px 0 rgba(0, 0, 0, .3)',
              'text-align': 'center',
          },
          position: markerPosition,
          offset: new AMap.Pixel(0, -45)
      });

      markerText.setMap(this.mapModule);
    }

    if(typeof(clickEvent)==="function"){
      marker.on('click',function(e){ clickEvent(e); });
    }

    this.mapModule.add(marker);

    return marker;
  }

  disableMap(){
    $(".amap-maps").css("pointer-events","none");
  }

  enableMap(){
    $(".amap-maps").css("pointer-events","");
  }

  view() {
    const mapContainerStyle = "width:"+this.mapWidth+";height:"+this.mapHeight;
    const mapInfoDataList = this.mapInfoDataList;
    const mapModuleID = this.mapModuleID;
    const mapModule = this.mapModule;
    const windowHeight = document.documentElement.clientHeight+"px";

    return (
      <div style={"height:"+windowHeight} className={this.mapClassName}>
        <div id={this.mapModuleID} style={mapContainerStyle}></div>
        <div id={this.mapModuleID+"TempContainer"} style="display:none;position: absolute;"></div>

      </div>
    );
  }
}